import { render, staticRenderFns } from "./KpiTile.vue?vue&type=template&id=39fcddb5&scoped=true"
import script from "./KpiTile.vue?vue&type=script&lang=js"
export * from "./KpiTile.vue?vue&type=script&lang=js"
import style0 from "./KpiTile.vue?vue&type=style&index=0&id=39fcddb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fcddb5",
  null
  
)

export default component.exports